import * as yup from 'yup'

const LearningPathValidator =  yup.object({
      learning_path: yup.string().required('Learning path is required'),
})

export { LearningPathValidator } 